import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'mlp-ng-sub-nav-vertical',
    templateUrl: './sub.nav.vertical.component.html',
    styleUrls: ['./sub.nav.vertical.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SubNavVerticalSharedComponent {
    @Input() links: any;
}
